import cn from 'classnames';
import styles from './SuccessActionContent.module.scss';
import { Button } from '../Button';

type SuccessActionContentProps = {
  className?: string;
  title: string;
  description?: string;
  buttonText: string;
  onClick: () => void;
};

export function SuccessActionContent({
  className,
  title,
  description,
  buttonText,
  onClick,
}: SuccessActionContentProps) {
  const wrapperClassName = cn(styles.success, className);

  return (
    <div className={wrapperClassName}>
      <img src="/svg/success.svg" alt="success" className={styles.icon} />
      <div className={styles.text}>
        <div className={styles.title}>{title}</div>
        {description && <div className={styles.description}>{description}</div>}
      </div>
      <Button text={buttonText} onClick={onClick} variant="primary" />
    </div>
  );
}
